// extracted by mini-css-extract-plugin
export default {"burguericon":"Burger_burguericon__lrW0J"};